export const LOCAL_PROXY_REQUEST_TIMEOUT_MS = 30_000;
